module.exports = __webpack_public_path__ + "img/symbol_4.190a1736.png";